import Immutable from 'immutable';

const suggestedResponseRecord = Immutable.Record({
    body: "",
    responseId: null,
    type: "text"
});

const initialSuggestedResponseState = Immutable.List([]);

const suggestedResponses = (state = initialSuggestedResponseState, action) => {
    switch (action.type) {
        case 'ADD_SUGGESTED_RESPONSES':
            state = state.clear();
            action.messages.forEach(message => {
                let newResponse = new suggestedResponseRecord({
                    body: message.body,
                    responseId: message.response_id,
                    type: message.type
                });
                state = state.push(newResponse);
            });
            return state;
        case 'ADD_SUGGESTIONS_FROM_HISTORY':
            action.historyItem.suggestedResponses.forEach(message => {
                let newResponse = new suggestedResponseRecord({
                    body: message.body,
                    responseId: message.responseId,
                    type: message.type
                });
                state = state.push(newResponse);
            });
            return state;
        case 'ADD_MESSAGE':
            return state.clear();
        case 'DELETE_MESSAGES':
            return state.clear();
        default:
            return state;
    }
}

export default suggestedResponses;


// WEBPACK FOOTER //
// ./src/reducers/suggested-responses.js